// Utilities
import {parseJsonAttribute} from '../../utilities/utilities';

// Components
import Submenu from './submenu';

const settings = {
    dataAttributes: {
        sectionId: 'data-section',
    },

    classNames: {
        selectedMobile: 'header--selected-mobile',
        selectedDesktop: 'header--selected-desktop',
        active: 'header--active',
    },

    selectors: {
        navItems: ':scope > div',
    },
};

export default class NavSection {
    constructor(
        container,
        submenuCallbacks,
    ) {
        this.container = container;
        this.sectionId = this.container
            .getAttribute(settings.dataAttributes.sectionId);
        this.visible = {
            mobile: false,
            desktop: false,
        };

        // Locate our DOM elements
        this.navItems = this.container
            .querySelectorAll(settings.selectors.navItems);

        if (this.navItems.length <= 0) {
            throw new Error('No nav items found for NavSection');
        }

        for (let i=0; i<this.navItems.length; i++) {
            const navItem = this.navItems[i];

            // Set active nav items based on current URL
            const anchorElements = navItem.querySelectorAll('a');
            let activeLink = null;
            for (let j=0; j<anchorElements.length; j++) {
                const anchorElement = anchorElements[j];

                // Check if this link's href attribute matches the current location
                // Note: "element.href" returns a full URL
                if (anchorElement.getAttribute('href') == window.location.pathname) {
                    activeLink = anchorElement;
                    break;
                }

                // Check if a data attribute was provided with alternates
                const parameters = parseJsonAttribute(
                    anchorElement,
                    'data-header',
                );

                if (parameters.alternateHrefs) {
                    for (let k=0; k<parameters.alternateHrefs.length; k++) {
                        const alternateHref = parameters.alternateHrefs[k];
                        if (alternateHref == window.location.pathname) {
                            activeLink = anchorElement;
                            break;
                        }
                    }

                    if (activeLink) {
                        break;
                    }
                }
            }

            if (activeLink) {
                navItem.classList.add(settings.classNames.active);

                const subNavItem = activeLink.closest('li');
                if (subNavItem) {
                    subNavItem.classList.add(settings.classNames.active);
                }
            }

            // If this item contains a <ul> element, it's a submenu
            const submenu = navItem.querySelector('ul');
            if (submenu) {
                new Submenu(
                    navItem,
                    navItem.firstElementChild,
                    submenu,
                    true,
                    submenuCallbacks,
                );
            }
        }
    }

    setMobileVisibility(visible) {
        if (visible == this.visible.mobile) {
            return;
        }

        if (visible) {
            this.container
                .classList
                .add(settings.classNames.selectedMobile);
        } else {
            this.container
                .classList
                .remove(settings.classNames.selectedMobile);
        }

        this.visible.mobile = visible;
    }

    setDesktopVisibility(visible) {
        if (visible == this.visible.desktop) {
            return;
        }

        if (visible) {
            this.container
                .classList
                .add(settings.classNames.selectedDesktop);
        } else {
            this.container
                .classList
                .remove(settings.classNames.selectedDesktop);
        }

        this.visible.desktop = visible;
    }
};
